import React, { useState } from "react";
import i18n from "i18next";

import { ButtonVariant } from "../../components/button/button.constants";
import { ClearfixContainer, Icon } from "../../UIElements";
import { colors } from "../../UIGlobals";
import { Button } from "../quiz.styled";

import { QuestionType } from "./question.constants";
import {
  QuestionTitle,
  QuestionSubtitle,
  WarnText,
  Header,
  QuestionAnswer,
  QuestionButtons,
} from "./question.styled";

const QuestionTitleWrapper = ({ value }) => <QuestionTitle dangerouslySetInnerHTML={{ __html: value }} />;

const QuestionAnswerWrapper = ({ value, action, active, preview, correct, children, multi }) => (
  <QuestionAnswer
    onClick={!preview ? action : () => {}}
    selected={active}
    correct={correct}
    preview={preview}
    multi={multi}
  >
    {value}
    {children}
  </QuestionAnswer>
);

const QuestionConfirm = ({ action, disabled }) => (
  <Button onClick={action} disabled={disabled}>
    { i18n.t("global.next") }
  </Button>
);

const QuestionBack = ({ action }) => (
  <Button onClick={action} variant={ButtonVariant.Outlined}>
    { i18n.t("global.previous") }
  </Button>
);

const Question = ({ question, callComplete, markAnswerSelected, navPrev, isFirst, preview }) => {
  const answers = question?.children.filter(question => question.type === "answer");
  const nothingSelected = !answers.some((answer) => answer.selected);
  const [showValidationMessage, setShowValidationMessage] = useState(false);

  const onNextClick = () => {
    if (nothingSelected) {
      setShowValidationMessage(true);
    } else {
      setShowValidationMessage(false);
      callComplete();
    }
  };

  return (
    <ClearfixContainer>
      <Header>
        {!!question && question.children
          .filter(question => question.type === "body")
          .map(question => <QuestionTitleWrapper {...question} key={question.value} />)}
        {question.params?.type === QuestionType.MultipleChoice && (
          <QuestionSubtitle>{i18n.t("quiz.question.multipleAnswersInfo")}</QuestionSubtitle>
        )}
      </Header>
      {answers.map((answer, index) => {
        return (
          <QuestionAnswerWrapper
            {...answer}
            key={index}
            multi={question.params && question.params.type === "multiple_choice"}
            action={() => markAnswerSelected(answer.parentId, answer.id)}
            active={answer.params.selected || answer.selected}
            preview={preview}
            correct={answer.params.correct}
          >
            {preview && answer.params.correct ? (
              <Icon icon="status_checkbox" size="13" color={colors().green} />
            ) : (
              preview && answer.params.selected && <Icon icon="close_fat" size="14" color={colors().red} />
            )}
          </QuestionAnswerWrapper>
        );
      })}
      {!preview && (
        <QuestionButtons isSingle={isFirst}>
          {showValidationMessage && nothingSelected && (
            <WarnText>
              {i18n.t("quiz.question.noAnswersMessage")}.
            </WarnText>
          )}
          {!isFirst && <QuestionBack action={navPrev} />}
          <QuestionConfirm action={onNextClick} disabled={nothingSelected} />
        </QuestionButtons>
      )}
    </ClearfixContainer>
  );
};

export default Question;
